import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uploading',
  templateUrl: './uploading.component.html',
  styleUrls: ['./uploading.component.css']
})
export class UploadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
